import { config } from "./config";
import axios from "axios";
import utils from "../utils";

let teamApi = {};

teamApi.getMembers = () => {
  return axios.post(`${config.url}/teams/${utils.fetchVariable("current_team")}/members`, {
    "show_bio": true,
    "show_online_status": false
  }, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

teamApi.getChannel = () => {
  return axios.get(`${config.url}/teams/${utils.fetchVariable("current_team")}/channels`, {
      headers: {
        BotzaToken: utils.fetchToken(),
      },
    });
};

teamApi.getTeamList = () => {
  return axios.get(`${config.url}/teams/list`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

teamApi.getTeams = () => {
  return axios.get(`${config.url}/teams/available`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

teamApi.connectTeam = (teamId) => {
  return axios.get(`${config.url}/teams/${teamId}/connect`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

teamApi.disconnectTeam = (teamId) => {
  return axios.get(`${config.url}/teams/${teamId}/disconnect`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

teamApi.createDefaultTeam = (teamId) => {
  return axios.get(`${config.url}/teams/create-default-team`, {
    headers: {
      BotzaToken: utils.fetchToken(),
    },
  });
};

export default teamApi;
